import {GlobalAgreementInfoVo} from '../../common/shared/api/nicolas/GlobalAgreementInfoVo.interface';
import {isTrue} from '../../common/shared/utils/isTrue';
import {GlobalAgreementInfo} from '../generated/types';
import {createAgreement} from './Agreement';

export function createGlobalAgreementInfo(
  agreementInfoVo: GlobalAgreementInfoVo,
  isWebView: boolean,
  isGlobal?: boolean
): GlobalAgreementInfo {
  const agreements = agreementInfoVo.agreement_layout.map(agreementVo =>
    createAgreement(agreementVo, isWebView, isGlobal)
  );

  return {
    isRegistered: isTrue(agreementInfoVo.is_registered),
    agreement: {
      itemList: agreements,
    },
  };
}
